import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";      // put your canvas code into src/App.jsx
import AdminCatalogPage from "./components/AdminCatalogPage.jsx";
import "./index.css";
import { CatalogProvider } from "./context/CatalogContext.jsx";
import { syncTokenFromUrl } from "./lib/auth.js";

syncTokenFromUrl();

const RootRouter = () => {
  const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
  if (normalizedPath === "/admin") {
    return <AdminCatalogPage />;
  }
  return <App />;
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <CatalogProvider>
      <RootRouter />
    </CatalogProvider>
  </React.StrictMode>
);
